/**
 * TanStack Query mutation for saving teacher note on attendance session.
 * PATCH /api/attendance-sessions/:id/teacher-note
 */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@client/lib/api-client';
import { sessionDashboardKeys } from './use-session-dashboard';

export function useUpdateTeacherNote(classId: string, sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ attendanceSessionId, teacherNote }: { attendanceSessionId: string; teacherNote: string | null }) =>
      api.patch<unknown>(`/api/attendance-sessions/${attendanceSessionId}/teacher-note`, { teacherNote }),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: sessionDashboardKeys.bySession(classId, sessionId),
      });
    },
  });
}
